export default __webpack_public_path__ + "static/media/Animations_Circle6.04e38fde.svg";